import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Button, UncontrolledTooltip, Input } from "reactstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Option } from "src/models/components/inputWrapperModel";
import {
  Columns,
  LazyTableState,
} from "src/models/components/dataTableWrapperModel";
import DataTableWrapper from "src/components/Grid/DataTableWrapper";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { useDispatch, useSelector } from "react-redux";
import ColumnAction from "src/components/Common/ColumnAction/ColumnAction";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../Calendar/DeleteModal";
import ArchiveModal from "../../Calendar/DeleteModal";
import { useToast } from "src/components/Common/ReactToaster";
import Select from "src/components/Common/Select";
import { CurrencyFormatter, formatDateMEL, saveAsExcelFile } from "src/helpers/common_helpers";
import { ROUTER } from "src/constants/routes";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { AnimatePresence, motion } from "framer-motion";
import { BUTTON_VARIANT } from "src/constants/bulkActionVariant";
import FeatherIcon from "feather-icons-react";
import CustomizeTable from "src/components/Common/CustomizeTable/CustomizeTable";
import TooltipMEL from "src/components/UI/Tooltip";
import BulkActionStatus from "src/components/Common/BulkActionStatus/BulkActionStatus";
import SortIcon from "src/components/Common/CustomFilterandSortIcon/SortIcon";
import { ACTIVE, DELETED } from "src/constants/commonConstants";
import ExportFile from "src/components/Common/ExcelPdf Export/ExportFile";
import FilterIcon from "src/components/Common/CustomFilterandSortIcon/FilterIcon";
import {
  clearTaxesMessage,
  deleteTaxesFromList,
  getDropDownTaxesListLoading,
  getTaxesList,
  getTaxesPageInvoicetypeDropdownLoading,
} from "src/store/actions";
import { taxes } from "src/models/pages/taxes";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import ValidationPopup from "src/components/Common/ValidationMessage/ValidationPopup";
import { API } from "src/util/api";
import { customizeTableColumns } from "src/models/components/CustomizeTableColumns";



export default function Taxes() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState(false);
  const [selectedTaxes, setSelectedTaxes] = useState<any>([]);
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);
  const partsListConverson = (values: any[]) => {
    const modifeidValue = values?.map((eachValue) => {
      let data: any = {};
      data['id'] = eachValue.id;
      data['name'] = eachValue?.name;
      data['sacNumber'] = eachValue?.sacNumber;
      data['priority'] = eachValue?.priority;
      data['startDate'] = eachValue?.startDate;
      data['endsAt'] = eachValue?.endDate;
      data['taxPercentage'] = eachValue?.taxPercentage;
      data['isDeleted'] = eachValue?.isDeleted;
      data['TaxTypeId'] = eachValue?.taxTypeList
      data['invoiceTypeList'] = eachValue?.invoiceTypeList
      return data;
    });
    return modifeidValue;
  }
  const { values, totalRecords } = useSelector((state: any) => state.taxesReducer.taxesList);
  const modifiedValues: any = partsListConverson(values.items);
  const { showToast } = useToast();
  const loading = useSelector((state: any) => state.taxesReducer.loading);
  const[pdfLoading,setPdfLoading]=useState<boolean>(false)

  const { message, paginatorCount, invoiceDropdown, taxDropDownList } = useSelector((state: any) => state.taxesReducer);
  // console.log("paginatorCount", paginatorCount)
  const error = useSelector((state: any) => state.taxesReducer.error);
  // console.log("erormesssss",error)
  const dispatch = useDispatch();
  const dt = useRef<DataTable<any>>(null);
  // for delete invoice
  const [deleteModal, setDeleteModal] = useState(false);
  // const [undoModal, setUndoModal] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const [rowData, setRowData] = useState<any>(null);
  const filterDetails: DataTableFilterMeta = {
    name: { value: "", matchMode: "contains" },
    sacnumber: { value: "", matchMode: "contains" },
    startDate: { value: "", matchMode: "contains" },
    StartDate: { value: "", matchMode: "contains" },
    StartToDate: { value: "", matchMode: "contains" },
    endsAt: { value: "", matchMode: "contains" },
    EndDate: { value: "", matchMode: "contains" },
    EndToDate: { value: "", matchMode: "contains" },
    TaxTypeId:{ value: "", matchMode: "contains" },
    invoiceTypeList:{ value: "", matchMode: "contains" },
    IsDeleted: { value: "false", matchMode: "contains" },
  };
  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 10,
    page: 1,
    // sortField: "",
    // sortOrder: 0,
    sortField: "CreationTime",
    sortOrder: -1,
    filters: filterDetails,
  };
  const [lazyState, setLazyState] = useState(initialLazyState);

  const initialValues = {
    status: "",
  };

  const onFilterClickHandler = () => {
    setFilter((preState) => !preState);
  };

  const onCreateClickHandler = () => {
    navigate(ROUTER.TAXES_CREATE);
  };

  const viewHandler = (rowData: any) => {
    navigate(`${ROUTER.TAXES_VIEW}/${rowData["id"]}`);
  };

  const editHandler = (rowData: any) => {
    navigate(`${ROUTER.TAXES_EDIT}/${rowData["id"]}`);
  };

  const deleteHandler = (rowData: any) => {
    setDeleteModal(true);
    setRowData(rowData);
  };
  const undoHandler = (rowData: any) => {
    setDeleteModal(true);
    setRowData(rowData);
  };

  useEffect(() => {
    dispatch(getDropDownTaxesListLoading());
    dispatch(getTaxesPageInvoicetypeDropdownLoading());
  }, [])

  const actionBodyTemplate = (rowData: any, field: string) => {
    return (
      <>
        {
          rowData.isDeleted == false ? (<ColumnAction
            displayData={rowData[field] as string}
            isEdit={true}
            isDelete={true}
            isView={true}
            onViewClick={() => viewHandler(rowData)}
            onEditClick={() => editHandler(rowData)}
            onDeleteClick={() => deleteHandler(rowData)}
          />
          ) : (
            <ColumnAction
              displayData={rowData[field] as string}
              undo={true}
              onDeleteClick={() => undoHandler(rowData)}
            />
          )
        }
      </>
      // <ColumnAction
      //   displayData={rowData[field] as string}
      //   isEdit={true}
      //   isDelete={true}
      //   isView={true}
      //   onViewClick={() => viewHandler(rowData)}
      //   onEditClick={() => editHandler(rowData)}
      //   onDeleteClick={() => deleteHandler(rowData)}
      // />
    );
  };

  const formatdatatype = (rowData: any, field?: string) => {
    let response = field ? rowData[field] : rowData
    const extractedTaxNames = response?.map((item: any) => item.taxName);
    if (extractedTaxNames?.length > 1) {
      const lastIndex = extractedTaxNames?.length - 1;
      extractedTaxNames[lastIndex] = "and " + extractedTaxNames[lastIndex];
    }
    const joinedTaxNames = extractedTaxNames?.join(", ");
    return joinedTaxNames
  }

  const formatdataInvoicetype = (rowData: any, field?: string) => {
    let response = field ? rowData[field] : rowData
    const extractedTaxNames = response?.map((item: any) => item.name);
    if (extractedTaxNames?.length > 1) {
      const lastIndex = extractedTaxNames?.length - 1;
      extractedTaxNames[lastIndex] = "and " + extractedTaxNames[lastIndex];
    }
    const joinedTaxNames = extractedTaxNames?.join(", ");
    return joinedTaxNames
  }

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading||pdfLoading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading,pdfLoading]);

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (error) {
      setVisible(true);
    }
  }, [error]);

  useEffect(() => {
    if (message) {
      showToast(message, { type: "success" });
      dispatch(clearTaxesMessage());
      setTimeout(() => {
        dispatch(getTaxesList(lazyState));
      }, 1000);
    }
  }, [message])

  const hidePopup = () => {
    setVisible(false);
    dispatch(clearTaxesMessage());
  };

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };

  const options: Option[] = [
    { label: "All", value: "All" },
    { label: "Active", value: "Active" },
    { label: "Deleted", value: "Deleted" },
  ];

  const currencyBodyTemplate = (rowData: taxes, field: string) => {
    let amount = rowData[field]
    return (<>{CurrencyFormatter({ value: amount })}</>)
  }

  useEffect(() => {
    setVisibleColumns(columns.filter((eachColumn: Columns) => eachColumn.isDefault))
  }, [invoiceDropdown,taxDropDownList])

  const TaxFilter = (options: ColumnFilterElementTemplateOptions) => {

    return (<>
      <Dropdown
        options={(taxDropDownList?.length > 0) ? (taxDropDownList?.map((eachSupplier: any) => {
          let data: any = {};
          data['label'] = eachSupplier?.taxName;
          data['value'] = eachSupplier?.id;
          return data;
        })) : []}
        name="audiobrandId"
        optionLabel="label"
        filter
        onChange={(e: DropdownChangeEvent) => {
          options.filterCallback(e.value, options.index)
          return {};
        }}
        required={true}
        value={options.value}
      />
    </>)
  };
  // const TaxFilter = (options: ColumnFilterElementTemplateOptions) => {
  //   return (
  //     <>
  //       <MultiSelect
  //         options={(taxDropDownList?.length > 0) ? (taxDropDownList?.map((eachSupplier: any) => {
  //           let data: any = {};
  //           data['label'] = eachSupplier?.taxName;
  //           data['value'] = eachSupplier?.id;
  //           return data;
  //         })) : []}
  //         name="audiobrandId"
  //         optionLabel="label"
  //         filter
  //         onChange={(e: any) => {
  //           options.filterCallback(e.value, options.index);
  //         }}
  //         required={true}
  //         value={options.value}
  //       />
  //     </>
  //   );
  // };
  const InvoiceFIlter = (options: ColumnFilterElementTemplateOptions) => {

    return (<>
      <Dropdown
        options={(invoiceDropdown?.length > 0) ? (invoiceDropdown?.map((eachSupplier: any) => {
          let data: any = {};
          data['label'] = eachSupplier?.name;
          data['value'] = eachSupplier?.id;
          return data;
        })) : []}
        name="audiobrandId"
        optionLabel="label"
        filter
        onChange={(e: DropdownChangeEvent) => {
          options.filterCallback(e.value, options.index)
          return {};
        }}
        required={true}
        value={options.value}
        itemTemplate={(option: any) => (
          <div
            title={option.label}
            style={{ display: "flex", alignItems: "center" }}
          >
            {option.label}
          </div>
        )}
      />
    </>)
  };
  const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    // console.log("options", options)
    return (<>
      <label htmlFor="">Start Date</label>
      <Input type="date" required value={options?.value?.startDate || ""} max={options?.value?.endDate ? options?.value?.endDate : ""} onChange={(e: any) => {
        options
        let modifiedDate: any = options.value || { startDate: "", endDate: "" }
        modifiedDate['startDate'] = e.target.value
        options.filterCallback(modifiedDate, options.index);
      }} />
      <br />
      <label htmlFor="">End Date</label>
      <Input type="date" required value={options?.value?.endDate || ""} min={options?.value?.startDate ? options?.value?.startDate : ""} onChange={(e: any) => {
        options
        let modifiedDate: any = options.value || { startDate: "", endDate: "" }
        modifiedDate['endDate'] = e.target.value
        options.filterCallback(modifiedDate, options.index);
      }} />
    </>)
  };

  const columns: Columns[] = [
    {
      field: "select",
      sortable: false,
      header: "",
      filter: false,
      showFilterMenu: false,
      selectionMode: "multiple",
      headerStyle: { width: "3rem", whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
      frozen : true,
    },
    {
      field: "name",
      sortable: true,
      header: "Name",
      filter: true,
      showFilterMenu: true,
      frozen : true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      body: (rowData) => actionBodyTemplate(rowData, "name"),
      isDefault: true,
      isStatic: true,
    },
    {
      field: "sacNumber",
      sortable: true,
      header: "Sac Number",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "taxPercentage",
      sortable: true,
      header: "Tax Percentage",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap",display:"flex",justifyContent:"end",height:"40px" },
      className: "align-right pr-2",
      isDefault: true,
      isStatic: false,
    },

    {
      field: "priority",
      sortable: true,
      header: "Priority",
      filter: false,
      showFilterMenu: false,
      className: "align-right pr-2",
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: false,
      isStatic: false,
    },
    {
      field: "startDate",
      sortable: true,
      header: "Starts At",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.startDate),
      filterElement: dateFilterTemplate,
      isDefault: true,
      isStatic: false,
    },
    {
      field: "endsAt",
      sortable: true,
      header: "Ends At",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.endsAt),
      filterElement: dateFilterTemplate,
      isDefault: true,
      isStatic: false,
    },
    {
      field: "invoiceTypeList",
      sortable: false,
      header: "Invoice Types",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      className:"partSku",
      body: (rowData) => formatdataInvoicetype(rowData, "invoiceTypeList"),
      isDefault: true,
      isStatic: false,
      filterElement:InvoiceFIlter
    },
    {
      field: "TaxTypeId",
      sortable: false,
      header: "Tax Types",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatdatatype(rowData, "TaxTypeId"),
      isDefault: true,
      isStatic: false,
      filterElement:TaxFilter
    },

  ];

  const [visibleColumns, setVisibleColumns] = useState(columns.filter((eachColumn: Columns) => eachColumn.isDefault));


  const changeColumnDetails = (values: any[]) => {
    let modifiedColumnDetails = values.map((eachDealer) => {
      const { id, name, sacNumber, taxPercentage, priority, startDate, endsAt, invoiceTypes, TaxTypeId } = eachDealer;
      let data: any = {};
      //data['id'] = id,
      data['Tax Name'] = name;
      data['SAC Number'] = sacNumber;
      data['Tax Percentage'] = taxPercentage;
      data['Priority'] = priority;
      data['Starts At'] = formatDateMEL(startDate);
      data['Ends At'] = formatDateMEL(endsAt);
      data['Tax Types'] = formatdatatype(TaxTypeId);
      return { ...data };
    });
    return modifiedColumnDetails;
  };

  const saveDataAsExcel = (values: any[], fileName: string) => {
    const modifiedColumnDetails = changeColumnDetails(values)
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(modifiedColumnDetails);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      saveAsExcelFile(excelBuffer, fileName);
    });
  };

  const saveDataAsPdf = (values: any[], columns: any[], fileName: string) => {
    // console.log("columns", columns)
    const destructureedData = values.map((data) => {
      let datas = {
        id: data.id,
        name: data.name,
        sacNumber: data.sacNumber,
        taxPercentage: data.taxPercentage,
        priority: data.priority,
        startDate: formatDateMEL(data.startDate),
        endsAt: formatDateMEL(data.endsAt),
        TaxTypeId: formatdatatype(data.TaxTypeId),
      };
      return datas;

    });
    // console.log("datas", destructureedData)
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const exportColumns = columns.map((col) => ({
          title: col.header,
          dataKey: col.field,
        }));
        const doc = new (jsPDF as any).default({
          orientation: 'portrait',
          format: 'a3',
        });
        doc.autoTable(exportColumns, destructureedData);
        doc.save(`${fileName}.pdf`);
      });
    });
  };

  const fetchData = async (isPdf:boolean) => {
    let lazy:any= {
      ...lazyState,
      rows:totalRecords>5000 ? 5000 : totalRecords<1 ? 1 : totalRecords,
      first:0,
      filters: {
        ...lazyState.filters,
      },
    };
	
    try {
      setPdfLoading(true)
      const response = await API.getTaxesListAPI(lazy);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      const value = response?.data?.items?.map((eachValue:any) => {
        let data: any = {};
        data['id'] = eachValue.id;
        data['name'] = eachValue?.name;
        data['sacNumber'] = eachValue?.sacNumber;
        data['priority'] = eachValue?.priority;
        data['startDate'] = eachValue?.startDate;
        data['endsAt'] = eachValue?.endDate;
        data['taxPercentage'] = eachValue?.taxPercentage;
        data['isDeleted'] = eachValue?.isDeleted;
        data['TaxTypeId'] = eachValue?.taxTypeList
        data['invoiceTypeList'] = eachValue?.invoiceTypeList
        return data;
      });
      // let resp=await partsListConverson(response?.data?.items)
     if(isPdf){

       saveDataAsPdf(value, columns, "Taxes");
     }else{
      saveDataAsExcel(value, "Taxes");
     }
     setPdfLoading(false)
    } catch (error:any) {
	  showToast(error.message,{type:"error"})
      setPdfLoading(false)
      
    } finally {
      setPdfLoading(false)
    }
  };

  const csvClickHandler = () => {
    // saveDataAsExcel(modifiedValues, "Taxes");
    fetchData(false)
  };

  const pdfClickHandler = () => {
    // saveDataAsPdf(modifiedValues, columns, "Taxes");
    fetchData(true)
  };

  const validationSchema = Yup.object({});

  const callbackFunction = (lazyState: LazyTableState) => {
    let modifiedLazyState: any = { ...lazyState };
    if (modifiedLazyState.filters && modifiedLazyState.filters.startDate) {
      modifiedLazyState.filters.startDate.value = "";
    }
    if (modifiedLazyState.filters && modifiedLazyState.filters.endsAt) {
      modifiedLazyState.filters.endsAt.value = "";
    }
    let obj=JSON.parse(JSON.stringify(lazyState))
    if(obj['sortField']==="endsAt"){
      obj['sortField']="endDate"
    }
    dispatch(getTaxesList(obj));
  };

  const [selectAll, setSelectAll] = useState(false);


  const onSelectionChange = (event: any) => {
    const value = event.value;
    setSelectedTaxes(value);
    setSelectAll(value.length === paginatorCount);
  };

  const onSelectAllChange = (event: any) => {
    const selectAll = event.checked;
    if (selectAll) {
      setSelectAll(true);
      setSelectedTaxes(modifiedValues);
    } else {
      setSelectAll(false);
      setSelectedTaxes([]);
    }
  };

  const handleStatusBlur = () => { };

  const onPage = (event: any) => {
    setLazyState(event);
  };

  const onSort = (event: any) => {


  setLazyState(event);


    setSelectedTaxes([]);
};


  const onFilter = (event: any) => {
    // console.log("event", event)
    event["first"] = 0;
    event['filters']['StartDate']['value'] = event?.filters?.startDate?.value?.startDate ? event?.filters?.startDate?.value?.startDate : ''
    event['filters']['StartToDate']['value'] = event?.filters?.startDate?.value?.endDate ? event?.filters?.startDate?.value?.endDate : ''
    event['filters']['EndDate']['value'] = event?.filters?.endsAt?.value?.startDate ? event?.filters?.endsAt?.value?.startDate : ''
    event['filters']['EndToDate']['value'] = event?.filters?.endsAt?.value?.endDate ? event?.filters?.endsAt?.value?.endDate : ''
    setLazyState(event);
  };

  const handleSubmit = (formValue: any) => {
    setselectedStatus(formValue);
    if (formValue == ACTIVE) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: "false", matchMode: "contains" },
        },
      }));
    }
    else if (formValue == DELETED) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: "true", matchMode: "contains" },
        },
      }));
    }
    else {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: null, matchMode: "contains" },
        },
      }));
    }
    setIsTooltipVisible(false)
    setVisibleColumns(visibleColumns)
  };

  const handleReset = (formValue: any) => {
    setLazyState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        status: {
          ...state.filters.status,lazyState,
          value: "",
        }
      },
    }));
  };

  useEffect(() => {
    setSelectAll(false);
    setSelectedTaxes([]);
    callbackFunction(lazyState);
  }, [lazyState]);


  const handleDeleteUsers = (rowData: any, length: number = 0, index: number = 0) => {
    let payload = {
      id: rowData["id"] ? rowData["id"] : rowData[0]?.id,
      undo: rowData?.isDeleted == true ? true : rowData[0]?.isDeleted == true ? true : false,
      lazyState,
    };
    dispatch(deleteTaxesFromList(payload));
    setDeleteModal(false);
    setRowData(null);
    if (index + 1 === length || index === length) {
      setSelectAll(false);
      setSelectedTaxes([]);
      // setTimeout(() => {        
      //     dispatch(getTaxesList(lazyState));        
      // }, 1000);
    }
  };




  const archiveHandler = () => {
    setSelectAll(false);
    setSelectedTaxes([]);
    setArchiveModal(false);
  };

  const defaultColumns = {
    ...columns[0]
  }

  const onColumnToggle = (event: MultiSelectChangeEvent) => {
    let selectedColumns = event.value;
    let orderedSelectedColumns = columns.filter((col) => selectedColumns.some((sCol: any) => sCol.field === col.field));

    setVisibleColumns([{ ...defaultColumns }, ...orderedSelectedColumns]);
  };

  const [showCustomizeTable, setShowCustomizeTable] = useState(false);
  const customizeTableClickHandler = () => {
    setShowCustomizeTable(true);
  };


  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  const [selectedStatus, setselectedStatus] = useState(ACTIVE);

  const bulkActionClickHandler = () => {
    if (modifiedValues.length > 0) {
      setSelectAll(true);
      setSelectedTaxes(modifiedValues);
    }
  };

  const cancelBulkActionHadler = () => {
    setSelectAll(false);
    setSelectedTaxes([]);
  };
  const customizeTableColumns: customizeTableColumns[] = columns.map((eachColumns: Columns) => {
    let data: any = {};
    data['field'] = eachColumns.field;
    data['value'] = visibleColumns.some((sCol: any) => sCol.field === eachColumns.field);
    data['isDisable'] = eachColumns.isStatic;
    data['header'] = eachColumns.header;
    return data;
  }).filter((eachColumns: customizeTableColumns) => eachColumns.field != 'select');
  const customizeTableCancelHandler = () => {
    setShowCustomizeTable(false);
  };
  const customizeColumnSubmitHandler = (customizeColumnObject: any[]) => {
    let orderedSelectedColumns = columns.filter((col) => customizeColumnObject.some((sCol: any) => sCol === col.field));

    setVisibleColumns([{ ...defaultColumns }, ...orderedSelectedColumns]);
    setShowCustomizeTable(false);
  };

  const clearFilter=()=>{
    setLazyState(initialLazyState)
    setselectedStatus(ACTIVE)
  }

  const header =
    <div className="table-header-container">
      <div>
        Taxes List
      </div>
      <div className="table-header-container-item table-header-container-item-special">
        {(selectedTaxes.length == 0 && selectedStatus!="All") && <Button type="button" className="customize-table-button mr-1 " onClick={bulkActionClickHandler}>
          <FeatherIcon icon="layers" className="mr-1" />
          Bulk actions
        </Button>}
        <AnimatePresence>
          {selectedTaxes.length > 0 &&
            <>
              {/* <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
            <Button type="button" className="secondary-btn  mr-1" onClick={() => { setArchiveModal(true); }}>
              <FeatherIcon icon="archive" className="mr-1" />
              Archive
            </Button>
          </motion.div> */}
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                <Button type="button" className="secondary-btn  mr-1 delete-space btn_space" onClick={() => { setDeleteModal(true); }}>
                  {selectedStatus == DELETED ? <><i className="fa fa-undo option-icons special"></i> <span className="remove_lables">Restore</span></> : <><FeatherIcon icon="trash-2" className="mr-1" /> <span className="remove_lables">Delete</span></>}
                </Button>
              </motion.div>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                <Button type="button" className="customize-table-button btn_space mr-1" onClick={cancelBulkActionHadler} > <FeatherIcon icon="x" className="" /> <span className="remove_lables">Cancel selection</span></Button>
              </motion.div>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                {selectedTaxes.length > 0 && <BulkActionStatus count={selectedTaxes.length} title="Taxes"></BulkActionStatus>}
              </motion.div>


            </>
          }
        </AnimatePresence>

      </div>
      <div className="flex-grow-1"></div>
      <div className="table-header-container-item">
        <div style={{ display: "flex" }}>
          <ExportFile exportExcel={csvClickHandler} exportPdf={pdfClickHandler} clearFilter={clearFilter} isFilter={true}/>
          <TooltipMEL title="Select Status" position="bottom" tooltipVisible={isTooltipVisible} setTooltipVisible={setIsTooltipVisible}>
            <Dropdown value={selectedStatus} onChange={(e) => handleSubmit(e.value)} options={options} optionLabel="label" placeholder="Select status .."
              filter className="w-full md:w-14rem" />
          </TooltipMEL>

        <Button type="button" className="customize-table-button" id="ScheduleUpdateTooltip"
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)} data-btn="btn" onClick={customizeTableClickHandler}>
          <FeatherIcon icon="sliders" className="" />
        </Button>
        </div>
        <div className="reponsive_position">
          {/* <TooltipMEL title="Add Taxes" position="bottom"> */}
          <Button type="button" className="btn btn-primary add_btn" onClick={onCreateClickHandler}>
            <FeatherIcon icon="plus-circle" className={"feathet-icon"} />
            Add Taxes
          </Button>
        </div>
        {/* </TooltipMEL> */}
        <UncontrolledTooltip
          placement="bottom"
          target="ScheduleUpdateTooltip"
          isOpen={tooltipOpen}
          toggle={toggleTooltip}
          innerClassName="tooltip-color"
        >
          Choose fields you want to see in the table
        </UncontrolledTooltip>
      </div>

    </div>;

  return (
    <>
      <div className="page-content">
        {visible && dialogContainer(error)}
        <DeleteModal
          show={deleteModal}
          undo={selectedStatus == DELETED ? true : false}
          onDeleteClick={() => {
            if (selectedTaxes?.length > 10) {
              showToast("Cannot delete more than 10 items at once", { type: "error" });
              setSelectedTaxes([]);
              setDeleteModal(false);
              setSelectAll(false);
              return setRowData(null);
            }

            if (rowData || selectedTaxes.length == 1) {
              handleDeleteUsers(rowData || selectedTaxes);
            } else if (selectedTaxes.length > 1) {
              for (let i = 0; i < selectedTaxes.length; i++) {
                handleDeleteUsers(selectedTaxes[i], selectedTaxes.length, i);
              }
            }
          }}
          onCloseClick={() => {
            setDeleteModal(false);
            setRowData(null);
          }}
        />
        <ArchiveModal
          show={archiveModal}
          message="you want to archieve these Taxes?"
          deleteLabel="Yes"
          closeLabel="No"
          onDeleteClick={() => {
            archiveHandler();
          }}
          onCloseClick={() => {
            setArchiveModal(false);
            setSelectAll(false);
            setSelectedTaxes([]);
          }}
        />
        {showCustomizeTable && <CustomizeTable onCancelHandler={customizeTableCancelHandler} onCustomizeColumnSubmitHandler={customizeColumnSubmitHandler} columns={customizeTableColumns} />}

        {filter && (
          <div className="card">
            <div className="card-body">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                onReset={handleReset}
                enableReinitialize
              >
                {({ values, handleChange }) => {
                  return (
                    <Form onChange={handleChange}>
                      <Row>
                        <Col xs={12} lg={7} id="export-search-clear">

                        </Col>
                        <Col xs={12} lg={5} id="export-search-clear d-flex">
                          <Select
                            label=""
                            name="status"
                            onBlur={handleStatusBlur}
                            value={values.status}
                            onChange={handleChange}
                            options={options}
                            invalid={false}
                          />
                          <Button className="btn btn-primary ms-2" color="primary" type="reset">
                            Clear </Button>
                          <Button className="btn btn-primary ms-2" color="primary" type="submit">
                            Search </Button>
                        </Col>


                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        )}
        <DataTableWrapper
          ref={dt}
          columnDetails={selectedStatus=="All"? [...visibleColumns]?.filter((items:any)=>items.field!="select") : visibleColumns}
          header={header}
          value={modifiedValues}
          lazy
          paginator={true}
          stripedRows={true}
          filterIcon={FilterIcon}
          rowHover={true}
          // filterDisplay="row"
          sortIcon={(setOrder) => <SortIcon order={setOrder} />}
          rowsPerPageOptions={[5, 10, 25, 50]}
          totalRecords={totalRecords}
          loading={loading}
          emptyMessage="No details found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Displaying Taxes  {last} records of {totalRecords} in total"
          selection={selectedTaxes}
          onSelectionChange={onSelectionChange}
          selectAll={selectAll}
          onSelectAllChange={onSelectAllChange}
          first={lazyState.first}
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          onFilter={onFilter}
          filters={lazyState.filters}
          onPage={onPage}
          rows={lazyState.rows}
        ></DataTableWrapper>
      </div>
    </>
  );
}
